import { CondosPageComponent } from './home/children/condos-page/condos-page.component';
import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { LoginPageComponent } from './login-page/login-page.component';
import { DashboardPageComponent } from './home/children/dashboard-page/dashboard-page.component';
import { LoggedGuard } from './guards/logged.guard';
import { WhiteLabelsPageComponent } from './home/children/whitelabels-page/white-labels-page.component';
import { WhiteLabelDetailsPageComponent } from './home/children/white-label-details-page/white-label-details-page.component';
import { WhiteLabelResolver } from './resolver/white-label.resolver';
import { CondosResolver } from './resolver/condos.resolver';
import { UsersPageComponent } from './home/children/users-page/users-page.component';
import { NotFoundPageComponent } from './not-found-page/not-found-page.component';
import { UserDetailsPageComponent } from './home/children/user-details-page/user-details-page.component';
import { UserResolver } from './resolver/user.resolver';
import { DashboardResolver } from './home/children/dashboard-page/dashboard.resolver';
import { CondosDetailsPageComponent } from './home/children/condos-details-page/condos-details-page.component';
import { CondoDetailsResolver } from './resolver/condo-details.resolver';
import { CreateWhiteLabelComponent } from './home/children/create-white-label-page/create-white-label-page';
import { CreateWhiteLabelResolver } from './resolver/create-white-label.resolver';
import { HomeComponent } from './home/home.component';
import { PartnersPageComponent } from './home/children/partners/partners-page/partners-page.component';
import { PartnersComponent } from './home/children/partners/partners-details/partners-details.component';
import { MarketplacePageComponent } from './home/children/marketplace/marketplace-page/marketplace-page.component';
import { BannersPageComponent } from './home/children/marketplace/banners/banners-page/banners-page.component';
import { CreateBannerPageComponent } from './home/children/marketplace/banners/create-banner-page/create-banner-page.component';
import { ContractsPageComponent } from './home/children/contracts-page/contracts-page.component';
import { CondoLogsPageComponent } from './home/children/logs-page/condo-logs-page/condo-logs-page.component';
import { UseTermsPageComponent } from './home/children/use-terms-page/use-terms-page.component';
import { UseTermsResolver } from './resolver/use-terms.resolver';
import { EcondosUseTermsResolver } from './resolver/econdos-use-terms.resolver';
import { FeaturesPageComponent } from './home/children/features-page/features-page.component';
import { HighlightsPageComponent } from './home/children/features-page/children/highlights-page/highlights-page.component';
import { CreateHighlightPageComponent } from './home/children/features-page/children/create-highlight-page/create-highlight-page.component';
import { CreateCondoFinancialInfoPageComponent } from './home/children/create-condo-financial-info-page/create-condo-financial-info-page';
import { CondoFinancialInfoPageComponent } from './home/children/condo-financial-info-page/condo-financial-info-page.component';
import { CreateCondoFinancialInfoResolver } from './resolver/create-condo-financial-info.resolver';
import { CommercialSystemAdminGuard } from './guards/commercialSystemAdmin.guard';
import { NoPermissionErrorPageComponent } from './no-permission-error-page/no-permission-error-page.component';
import { HardwareLogsPageComponent } from './home/children/logs-page/hardware-logs-page/hardware-logs-page.component';
import { SystemBroadcastPageComponent } from './home/children/features-page/children/system-broadcast-page/system-broadcast-page.component';
import { CreateSystemBroadcastPageComponent } from './home/children/features-page/children/create-system-broadcast-page/create-system-broadcast-page.component';
import { EcameraPageComponent } from './home/children/ecamera-page/ecamera-page.component';

const routes: Routes = [
  {
    path: '',
    redirectTo: 'home',
    pathMatch: 'full',
    title: 'Home'
  },
  {
    path: 'home',
    component: HomeComponent,
    canActivate: [LoggedGuard],
    title: 'Home',
    children: [
      { path: '', redirectTo: 'dashboard', pathMatch: 'full', title: 'Dashboard' },
      {
        path: 'dashboard',
        component: DashboardPageComponent,
        resolve: { data: DashboardResolver },
        title: 'Dashboard'
      },
      {
        path: 'partners',
        component: PartnersPageComponent,
        title: 'Parceiros'
      },
      {
        path: 'partners/new',
        component: PartnersComponent,
        title: 'Novo Parceiro'
      },
      {
        path: 'partners/:partnerId/edit',
        component: PartnersComponent,
        title: 'Editar Parceiro'
      },
      {
        path: 'marketplace',
        title: 'Marketplace',
        children: [
          {
            path: '',
            component: MarketplacePageComponent,
            title: 'Marketplace'
          },
          {
            path: 'new',
            component: MarketplacePageComponent,
            title: 'Novo Marketplace'
          },
          {
            path: 'banners',
            title: 'Banners',
            children: [
              { path: '', component: BannersPageComponent, title: 'Banners' },
              { path: 'new', component: CreateBannerPageComponent, title: 'Novo Banner' },
              { path: ':bannerId', component: CreateBannerPageComponent, title: 'Editar Banner' }
            ]
          }
        ]
      },
      {
        path: 'whitelabels',
        component: WhiteLabelsPageComponent,
        title: 'White Labels'
      },
      {
        path: 'whitelabels/create',
        component: CreateWhiteLabelComponent,
        title: 'Criar White Label'
      },
      {
        path: 'whitelabels/:whiteLabelId',
        component: WhiteLabelDetailsPageComponent,
        resolve: {
          whiteLabel: WhiteLabelResolver,
          condos: CondosResolver
        },
        title: 'Detalhes White Label'
      },
      {
        path: 'whitelabels/:whiteLabelId/edit',
        component: CreateWhiteLabelComponent,
        resolve: {
          whiteLabel: CreateWhiteLabelResolver
        },
        title: 'Editar White Label'
      },
      {
        path: 'whitelabels/:whiteLabelId/use-terms',
        component: UseTermsPageComponent,
        resolve: {
          whiteLabel: WhiteLabelResolver,
          useTerms: UseTermsResolver
        },
        title: 'Termos de Uso'
      },
      {
        path: 'users',
        component: UsersPageComponent,
        title: 'Usuários'
      },
      {
        path: 'users/:userId',
        component: UserDetailsPageComponent,
        resolve: { user: UserResolver },
        runGuardsAndResolvers: 'paramsChange',
        title: 'Detalhes do Usuário'
      },
      {
        path: 'condos',
        component: CondosPageComponent,
        title: 'Condomínios'
      },
      {
        path: 'condos/:condoId',
        component: CondosDetailsPageComponent,
        resolve: {
          condos: CondoDetailsResolver
        },
        title: 'Detalhes do Condomínio'
      },
      {
        path: 'contracts',
        component: ContractsPageComponent,
        title: 'Contratos'
      },
      {
        path: 'logs',
        title: 'Logs',
        children: [
          { path: '', redirectTo: 'condos', pathMatch: 'full', title: 'Logs de Condomínios' },
          {
            path: 'condos',
            component: CondoLogsPageComponent,
            title: 'Logs de Condomínios'
          },
          {
            path: 'hardwares',
            component: HardwareLogsPageComponent,
            title: 'Logs de Hardware'
          }
        ]
      },
      {
        path: 'features',
        component: FeaturesPageComponent,
        title: 'Funcionalidades'
      },
      {
        path: 'features/highlights',
        component: HighlightsPageComponent,
        title: 'Destaques'
      },
      {
        path: 'features/highlights/create',
        component: CreateHighlightPageComponent,
        title: 'Criar Destaque'
      },
      {
        path: 'features/highlights/:highlightId/edit',
        component: CreateHighlightPageComponent,
        title: 'Editar Destaque'
      },
      {
        path: 'features/system-broadcasts',
        component: SystemBroadcastPageComponent,
        title: 'Transmissões do Sistema'
      },
      {
        path: 'features/system-broadcasts/create',
        component: CreateSystemBroadcastPageComponent,
        title: 'Criar Transmissão'
      },
      {
        path: 'features/system-broadcasts/:systemBroadcastId/edit',
        component: CreateSystemBroadcastPageComponent,
        title: 'Editar Transmissão'
      },
      {
        path: 'use-terms',
        component: UseTermsPageComponent,
        resolve: {
          econdos: EcondosUseTermsResolver
        },
        title: 'Termos de Uso'
      },
      {
        path: 'condoFinancialInfo',
        component: CondoFinancialInfoPageComponent,
        canActivate: [CommercialSystemAdminGuard],
        title: 'Informações Financeiras'
      },
      {
        path: 'condoFinancialInfo/create',
        component: CreateCondoFinancialInfoPageComponent,
        canActivate: [CommercialSystemAdminGuard],
        title: 'Criar Informação Financeira'
      },
      {
        path: 'condoFinancialInfo/:condoFinancialInfoId/edit',
        component: CreateCondoFinancialInfoPageComponent,
        resolve: {
          condoFinancialInfo: CreateCondoFinancialInfoResolver
        },
        canActivate: [CommercialSystemAdminGuard],
        title: 'Editar Informação Financeira'
      },
      {
        path: 'ecamera',
        component: EcameraPageComponent,
        title: 'E-Camera'
      }
    ]
  },
  { path: 'login', component: LoginPageComponent, title: 'Login' },
  { path: 'notFound', component: NotFoundPageComponent, canActivate: [LoggedGuard], title: 'Página Não Encontrada' },
  { path: 'no-permission-error', component: NoPermissionErrorPageComponent, canActivate: [LoggedGuard], title: 'Sem Permissão' },
  // Redirect for not found routes - SEMPRE DEVE SER A ÚLTIMA ROTA
  { path: '**', redirectTo: '/notFound', title: 'Página Não Encontrada' }
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule {}
